"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactWidgets = require("react-widgets");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _grid = _interopRequireDefault(require("cccisd-icons/grid6"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var resourceFields = ['displayOptions.resources.showPageControls', 'displayOptions.resources.showThumbnail', 'displayOptions.resources.showDescription', 'displayOptions.resources.showTags', 'displayOptions.resources.showShareButton', 'displayOptions.resources.showShareIconOnly', 'displayOptions.resources.showFavoriteIcon', 'displayOptions.resources.uppercaseTitle', 'displayOptions.resources.titleColor', 'displayOptions.resources.shareButtonColor', 'displayOptions.resources.renderMode', 'displayOptions.resources.coverThumbnails', 'displayOptions.resources.showFilterGroupIcons', 'displayOptions.resources.showSurveyPreviewMessage', 'displayOptions.resources.hideSearchBar', 'displayOptions.resources.hideShowingResources', 'displayOptions.resources.hidePerPageDropdown', 'displayOptions.resources.hideDisplayLayoutToggle', 'displayOptions.resources.featuredResourceList'];
var fields = exports.fields = [].concat(resourceFields);
function ResourceDisplayOptions(props) {
  // {`id`: `label`} map instead of array for faster lookup
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    resourcesList = _useState2[0],
    setResourcesList = _useState2[1];
  (0, _react.useEffect)(function () {
    function getResourcesList() {
      return _getResourcesList.apply(this, arguments);
    }
    function _getResourcesList() {
      _getResourcesList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _resp$data;
        var resp, _resp$data2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _cccisdAxios["default"].get(Boilerplate.route('api.resources.resource.index'), {
                params: {
                  scope: props.settings.id
                }
              });
            case 1:
              resp = _context.v;
              if (Array.isArray(resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.data)) {
                setResourcesList(resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.data.reduce(function (all, curr) {
                  all[curr.id] = curr.published_label || curr.draft_label;
                  return all;
                }, {}));
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _getResourcesList.apply(this, arguments);
    }
    if (!resourcesList) {
      getResourcesList();
    }
    return function () {
      return setResourcesList(null);
    };
  }, []);
  var displayOptions = props.fields.displayOptions;
  var defaultPerPageOption = displayOptions.portal.defaultPerPageOption;
  var _displayOptions$resou = displayOptions.resources,
    showPageControls = _displayOptions$resou.showPageControls,
    showThumbnail = _displayOptions$resou.showThumbnail,
    showDescription = _displayOptions$resou.showDescription,
    showTags = _displayOptions$resou.showTags,
    showShareButton = _displayOptions$resou.showShareButton,
    showShareIconOnly = _displayOptions$resou.showShareIconOnly,
    showFavoriteIcon = _displayOptions$resou.showFavoriteIcon,
    uppercaseTitle = _displayOptions$resou.uppercaseTitle,
    renderMode = _displayOptions$resou.renderMode,
    coverThumbnails = _displayOptions$resou.coverThumbnails,
    showFilterGroupIcons = _displayOptions$resou.showFilterGroupIcons,
    showSurveyPreviewMessage = _displayOptions$resou.showSurveyPreviewMessage,
    hideSearchBar = _displayOptions$resou.hideSearchBar,
    hideShowingResources = _displayOptions$resou.hideShowingResources,
    hidePerPageDropdown = _displayOptions$resou.hidePerPageDropdown,
    hideDisplayLayoutToggle = _displayOptions$resou.hideDisplayLayoutToggle,
    featuredResourceList = _displayOptions$resou.featuredResourceList;
  var resourceOptions = [{
    field: showThumbnail,
    label: 'Show Thumbnail'
  }, {
    field: showDescription,
    label: 'Show Description'
  }, {
    field: showTags,
    label: 'Show Tags'
  }, {
    field: showShareButton,
    label: 'Show Share Button'
  }, {
    field: showShareIconOnly,
    label: 'Show Share Icon Only'
  }, {
    field: showFavoriteIcon,
    label: 'Allow Favorites'
  }, {
    field: uppercaseTitle,
    label: 'Uppercase Title'
  }, {
    field: coverThumbnails,
    label: 'Cover Thumbnails',
    tooltip: 'Thumbnail will cover entire left side or entire top of the resource.'
  }, {
    field: showSurveyPreviewMessage,
    label: 'Show Survey Preview Message',
    tooltip: 'Informs user that resource will be shown in preview mode and no responses will be saved. Message language can be customized.'
  }, {
    field: showFilterGroupIcons,
    label: 'Show Filter Group Icons'
  }];
  var showPage = [{
    field: showPageControls,
    label: 'Show Page Controls',
    tooltip: 'This will remove pagination, which may hide some resources from view. Only' + ' turn this off if the number of resources will be less than the Resorces Per Page listed above.'
  }];
  var showPageControlOptions = [{
    field: hideSearchBar,
    label: 'Hide Search Bar'
  }, {
    field: hideShowingResources,
    label: 'Hide Showing X of Y Resources'
  }, {
    field: hidePerPageDropdown,
    label: 'Hide Per Page Dropdown'
  }, {
    field: hideDisplayLayoutToggle,
    label: 'Hide Display Layout'
  }];
  var perPageOptions = [{
    value: 5,
    label: '5'
  }, {
    value: 10,
    label: '10'
  }, {
    value: 15,
    label: '15'
  }, {
    value: 25,
    label: '25'
  }, {
    value: 50,
    label: '50'
  }];
  var renderModeOptions = [{
    value: 'list',
    label: 'List'
  }, {
    value: 'grid',
    label: 'Grid'
  }];

  // Prevent breaking change from adding the new key showPageControls
  if (![true, false].includes(showPageControls.value)) {
    showPageControls.onChange(true);
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card card-body",
    style: {
      backgroundColor: '#f5f5f5'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: defaultPerPageOption,
    label: "Resources Per page"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "form-select",
    value: defaultPerPageOption.value,
    onChange: function onChange(e) {
      return defaultPerPageOption.onChange(Number(e.target.value));
    },
    style: {
      width: 'auto'
    }
  }, perPageOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3 mb-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group d-block",
    role: "group",
    "aria-label": "..."
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label",
    htmlFor: "resourceDisplay"
  }, "Resources Display"), /*#__PURE__*/_react["default"].createElement("div", {
    id: "resourceDisplay"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group "
  }, renderModeOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: option.value,
      type: "button",
      className: 'btn btn-secondary ' + (option.value === renderMode.value ? 'active' : ''),
      onClick: function onClick() {
        renderMode.onChange(option.value);
      }
    }, option.value === 'list' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "List ", /*#__PURE__*/_react["default"].createElement(_menu["default"], null)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Grid ", /*#__PURE__*/_react["default"].createElement(_grid["default"], null)));
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: featuredResourceList,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Featured Resources", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Featured resources will always be sorted to the top of the list"
    }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
      spaceLeft: true
    })))
  }, /*#__PURE__*/_react["default"].createElement(_reactWidgets.Multiselect, {
    dataField: "id",
    textField: "label",
    busy: !resourcesList,
    value: Array.isArray(featuredResourceList.value) && resourcesList ? featuredResourceList.value.reduce(function (all, id) {
      if (id in resourcesList) {
        all.push({
          id: id,
          label: resourcesList[id]
        });
      }
      return all;
    }, []) : [],
    data: resourcesList && _typeof(resourcesList) === 'object' ? Object.keys(resourcesList).map(function (id) {
      return {
        id: id,
        label: resourcesList[id]
      };
    }).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    }) : [],
    onChange: function onChange(selected) {
      featuredResourceList.onChange(selected.map(function (r) {
        return r.id;
      }));
    },
    tagComponent: function tagComponent(_ref) {
      var item = _ref.item;
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: item.id,
        className: "text-wrap me-2 d-inline-block text-start"
      }, item.label);
    },
    itemComponent: function itemComponent(_ref2) {
      var item = _ref2.item;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: item.id,
        className: "border-bottom border-dark-subtle border-1 py-1 lh-1"
      }, item.label);
    }
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, resourceOptions.map(function (resource) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-3 mb-3",
      key: resource.label
    }, resource.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: /*#__PURE__*/_react["default"].createElement("span", null, resource.label, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: resource.tooltip
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: resource.label
    }));
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label",
    htmlFor: "pageControls"
  }, "Page Controls"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, showPage.map(function (resource) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: resource.label,
      className: "mb-3"
    }, resource.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: /*#__PURE__*/_react["default"].createElement("span", null, resource.label, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: resource.tooltip
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: resource.label
    }));
  }), showPageControls.checked === true ? showPageControlOptions.map(function (resource) {
    return /*#__PURE__*/_react["default"].createElement("h6", {
      key: resource.label
    }, resource.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: /*#__PURE__*/_react["default"].createElement("span", null, resource.label, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: resource.tooltip
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: resource.label
    }));
  }) : null));
}
var _default = exports["default"] = ResourceDisplayOptions;